module.exports = __webpack_public_path__ + "fonts/IBMPlexSans-SemiBold.0896d328.ttf";